// 确保 AMap 已加载的工具函数
export const ensureAMapLoaded = () => {
  return new Promise((resolve, reject) => {
    if (window.AMap) {
      resolve(window.AMap);
      return;
    }

    // 如果还没加载，设置一个轮询检测
    let checkCount = 0;
    const maxCheckCount = 50; // 最多检查5秒（50*100ms）

    const checkAMap = () => {
      if (window.AMap) {
        resolve(window.AMap);
      } else if (checkCount < maxCheckCount) {
        checkCount++;
        setTimeout(checkAMap, 100);
      } else {
        reject(new Error("AMap 加载超时，请检查网络和高德Key配置"));
      }
    };

    checkAMap();
  });
};

// 获取 AMap 实例
export const getAMap = async () => {
  return await ensureAMapLoaded();
};
